// Inference availability flag.
//
// Flipped to `true` by the apiFetch wrapper in lib/api.ts the moment a
// product API call returns 503 inference_unavailable. Flipped back to
// `false` when any subsequent /v1/* call succeeds (which means the API
// is reachable and the gateway behind it is too — at minimum, healthy
// non-AI calls survive while AI surfaces stay hidden).
//
// Read by the Header to render an unobtrusive "AI OFFLINE" pill, and by
// AI-aware components to hide their affordance.

import { create } from 'zustand';

interface InferenceStatusState {
  offline: boolean;
  setOffline: (next: boolean) => void;
}

export const useInferenceStatus = create<InferenceStatusState>((set) => ({
  offline: false,
  setOffline: (next) => set((s) => (s.offline === next ? s : { offline: next })),
}));
